import React from 'react';

export default function DisplayTemperature({ value }) {
	if (value == null) return null;
	return <span>{value} &deg;C</span>;
}